import React, { useEffect, useState, useRef, useCallback } from "react";
// import { Button } from "@digitallabs/one-x-ui";
import { Button } from "../../resourses/digitallabs/one-x-ui";
import DMQCustomCard from "../../components/common/DMQCustomCard";
import DynamicFormRenderer_Helix from "../../components/dynamicRendering/DyamicFormRenderer_Helix";

import {
  saveStepData,
  getStoredFormData,
  clearCurrentInternalStep,
  saveCurrentInternalStep,
  getCurrentInternalStep,
  getEditingMode,
  getQuestionBank,
  setEditingMode,
  getDMQStepFlow,
} from "../../utils/formStorage";

import { useLoader } from "../../context/LoaderContext";

import { DMQStepNames, MAIN_STEPS } from "../../constants/constants";

import { checkUserInactivity } from "../../utils/checkUserInactivity";
import { withAuth } from "../../utils/withAuth";

import FormFooter from "../../components/common/FormFooter";

const StepThyroidQuestionnaire = ({ handleStepChange }) => {
  const { setLoading } = useLoader();
  const formRef = useRef(null);

  const [formState, setFormState] = useState({});
  const [renderingJSON, setRenderingJSON] = useState([]);
  const [internalStep, setInternalStep] = useState(getCurrentInternalStep() || 0);
  const [isFormValid, setIsFormValid] = useState(false);

  const questionBank = getQuestionBank();

  /*
  HANDLE FIELD CHANGE
  */
  const handleChange = useCallback((name, value) => {
    setFormState((prev) => {
      if (Object.is(prev[name], value)) return prev;
      return {
        ...prev,
        [name]: value,
      };
    });
  }, []);

  /*
  LISTEN FOR HEADER BACK BUTTON STEP CHANGE
  */
  useEffect(() => {
    const syncInternalStep = (event) => {
      if (event.detail?.internalStep !== undefined) {
        setInternalStep(event.detail.internalStep);
      }
    };

    window.addEventListener("dmq-step-change", syncInternalStep);

    return () => {
      window.removeEventListener("dmq-step-change", syncInternalStep);
    };
  }, []);

  /*
  INITIAL LOAD
  */
  useEffect(() => {
    setLoading(true);

    const stored = getStoredFormData() || {};

    setRenderingJSON(questionBank[DMQStepNames.THYROID_QUESTIONNAIRE]);
    setFormState(stored[DMQStepNames.THYROID_QUESTIONNAIRE] || {});

    setLoading(false);
  }, []);

  /*
  SCROLL TO TOP
  */
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  /*
  FORM SUBMIT
  */
  const onFinish = (values) => {
    checkUserInactivity(null, async () => {
      setLoading(true);

      saveStepData(DMQStepNames.THYROID_QUESTIONNAIRE, values);

      const isEditing = getEditingMode();

      if (isEditing === false) {
        /*
      GET STEP FLOW FROM LOCAL STORAGE
      */

        const stepFlow = getDMQStepFlow();
        const currentIndex = stepFlow.findIndex((step) => step.id === MAIN_STEPS.THYROID_QUESTIONNAIRE);
        const nextStep = stepFlow[currentIndex + 1];

        if (!nextStep) {
          setLoading(false);
          return;
        }

        /*
      NAVIGATE BASED ON NEXT STEP ID
      */

        if (nextStep.id === MAIN_STEPS.CONFIRM_DETAILS) {
          handleStepChange(MAIN_STEPS.CONFIRM_DETAILS);
          clearCurrentInternalStep();
        } else {
          handleStepChange(nextStep.id);
          saveCurrentInternalStep(0);
        }
      } else {
        handleStepChange(MAIN_STEPS.CONFIRM_DETAILS);
        clearCurrentInternalStep();
        setEditingMode(false);
      }

      setLoading(false);
    });
  };

  /*
  FORM VALIDATION STATE
  */
  const onValidationChange = useCallback((isValid) => {
    setIsFormValid((prev) => (prev === isValid ? prev : isValid));
  }, []);

  return (
    <div style={{ paddingBottom: "80px" }}>
      <DMQCustomCard
        title={"Thyroid Questionnaire"}
        subtitle={"Please answer a few quick questions about your health"}
        pageHeader={null}
        totalDots={0}
        activeDot={internalStep}
      >
        <DynamicFormRenderer_Helix
          ref={formRef}
          step={MAIN_STEPS.THYROID_QUESTIONNAIRE}
          internalStep={internalStep}
          schema={renderingJSON}
          formState={formState}
          handleChange={handleChange}
          onFormFinish={() => onFinish(formState)}
          onFormValidityChange={onValidationChange}
        />
      </DMQCustomCard>

      <FormFooter>
        <Button
          variant="primary"
          size="md"
          fullWidth
          className={!isFormValid ? "next-btn-disabled" : ""}
          onClick={() => formRef.current?.triggerNext()}
        >
          {getEditingMode() ? "Confirm" : "Next"}
        </Button>
      </FormFooter>
    </div>
  );
};

export default withAuth(StepThyroidQuestionnaire);
